import 'air-datepicker/air-datepicker.css';
import AirDatepicker from 'air-datepicker';

export default {
    mounted(el, binding) {
        // Get the datepicker options from binding.value
        const options = binding.value || {};

        // Parse the date if it exists
        const parsedDate = el.dataset.selectedDate ? new Date(el.dataset.selectedDate) : null;
        
        const defaultOptions = {
            locale: {
                days: [
                    'Sunday',
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday'
                ],
                daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                months: [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December'
                ],
                monthsShort: [
                    'Jan',
                    'Feb',
                    'Mar',
                    'Apr',
                    'May',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dec'
                ],
                today: 'Today',
                clear: 'Clear',
                dateFormat: 'dd/MM/yyyy',
                timeFormat: 'HH:mm',
                firstDay: 0, // Sunday
                autoClose: true
            },
            ...options // Merge custom options passed to the directive
        };

        // Initialize the Air Datepicker with the merged options
        el._datepicker = new AirDatepicker(el, defaultOptions);

        // Set input value from the current value
        if (parsedDate) {
            el._datepicker.selectDate(parsedDate);
        }        
    },
    beforeUnmount(el) {
        if (el._datepicker) {
            el._datepicker.destroy();
        }
    }
};
